export enum NumberInputTypes {
    INTEGER = 'INTEGER',
    FLOAT = 'FLOAT',
    POSITIVE_INTEGER = 'POSITIVE_INTEGER',
    POSITIVE_FLOAT = 'POSITIVE_FLOAT',
}

export const REGEXP_MAP = {
    [NumberInputTypes.INTEGER]: /^[-0-9]*$/,
    [NumberInputTypes.FLOAT]: /^[-0-9.]*$/,
    [NumberInputTypes.POSITIVE_INTEGER]: /^\d*$/,
    [NumberInputTypes.POSITIVE_FLOAT]: /^[0-9.]*$/,
};
